module.exports = __webpack_public_path__ + "static/mobile-b629f47b84f3e7150a576c304b6dfac9.png";